import RestService from './RestService';
import { ApiRoutes } from './apiRoutes';

/**
 * Service for making JWT-related API calls
 * This service is separate from JwtAuthService to prevent circular dependencies
 */
export const JwtApiService = {
  /**
   * Verify a JWT token with the server
   * @param token JWT token to verify
   * @returns Promise resolving to true if token is valid, false otherwise
   */
  verifyToken: async (token: string): Promise<boolean> => {
    try {
      await RestService.get(
        ApiRoutes.VERIFY
      );
      
      return true;
    } catch (error) {
      console.error('Error verifying JWT token:', error);
      return false;
    }
  },

  logout: async () => {
    try {
      await RestService.post(ApiRoutes.LOGOUT);
    } catch (error) {
      console.error('Error logging out:', error);
    }
  },

  ttl: async (): Promise<number> => {
    try {
      const response = await RestService.get(ApiRoutes.TTL);
      // Ensure we return a number by using parseInt or Number conversion
      return typeof response === 'object' && response !== null && 'ttl' in response
        ? Number(response.ttl)
        : -2;
    } catch (error) {
      console.error('Error getting TTL:', error);
      return -2;
    }
  },
};

export default JwtApiService; 